<template>
  <div>
    <Title :title="'可用电池信息'"></Title>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from '../chart.vue';
import Title from '../../title';
import { dataInterface } from '@/api/dataInterfaceApi';


export default {
  data () {
    return {
      userAddCurrentList:[],//新增用户
      userActivityCurrentList:[],//活跃度
      cdata: {
        category: [],
        rateData: [],
        id:"userAddChart",
        legendData:[{
              name:"充电中",
              icon: 'roundRect',
            }, {
              name:"可用",
              icon: 'roundRect',
        }, {
              name:"其他",
              icon: 'roundRect',
        }],
        series:[
            {
              name: "充电中",
              type: "bar",
              stack: 'one',
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#65E2B6" },
                    { offset: 1, color: "#B8FF7E" }
                  ])
                }
              },
              data: []
            },
            {
              name: "可用",
              type: "bar",
              stack: 'one',
              barWidth: 10,
              itemStyle: {
                normal: {
                  
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#027BF7" },
                    { offset: 1, color: "#3D9FFF" }
                  ])
                }
              },
              data: []
            },
            {
              name: "其他",
              type: "bar",
              stack: 'one',
              barWidth: 10,
              // itemStyle: {
              //   normal: {
              //     color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              //       { offset: 0, color: "#00FFFF" },
              //       { offset: 1, color: "#010D44" }
              //     ])
              //   }
              // },
              itemStyle: {
                color: "#90F3FF" 
              },
              data: []
            },
        ]
      }
    };
  },
  components: {
    Chart,
    Title,
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.selectStationBatteryInfo(data)
    },
    selectStationBatteryInfo(data={}){
      let _this = this;
      let params = {
        '@station_id':data.stationId,
        "enCode":"TiDB-zhandian-keyongdianchishu"
      }
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          let batteryModelList = [];
          let chargePowerFinishList = [];//充电完成
          let chargePowerList=[];//充电中
          let battertNameNumOther = [];
          res.forEach(item=>{
            batteryModelList.push(item.battery_name);
            chargePowerList.push(item.battertNameNumCharging);
            chargePowerFinishList.push(item.battertNameNumFinish);
            battertNameNumOther.push(item.battertNameNumOther);
          })
          this.cdata.series[0].data = chargePowerList;
          this.cdata.series[1].data = chargePowerFinishList;
          this.cdata.series[2].data = battertNameNumOther;
          this.cdata.category = batteryModelList;
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }
};
</script>

<style lang="scss" scoped>
</style>